export default __webpack_public_path__ + "static/media/health-wellness1.0f92b251.jpg";